<div class="row">
  <div class="col-sm-1" style="font-weight: bold;">
    {{element.index+1}}
  </div>
  <div class="col-sm-10" style="white-space: pre-line; font-weight: bold;">
    {{element.question?.split('\\n').join('\n')}}
  </div>
  <div class="col-sm-1">
    <input type="checkbox" (click)="onAgreeClick()">
  </div>
</div>